import { AddToQueue as DefaultBulkAddToQueueButton } from 'customer-data-bulk-actions/components/buttons/tasks/AddToQueue';
import { DefaultBulkActionsUpdateTasksOnSuccess } from 'customer-data-bulk-actions/hooks/tasksBulkActionsHooks/tasksCrud';
import { useCallback } from 'react';
import { useDispatch } from '../../context/Redux';
import { logBulkActionUpdate, mergeTaskPropertyUpdates } from '../../redux/actions/tasksCRUD';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BulkAddToQueue({
  selection,
  clearSelection
}) {
  const dispatch = useDispatch();
  const onSuccess = useCallback(({
    count,
    propertyUpdates
  }) => {
    DefaultBulkActionsUpdateTasksOnSuccess({
      count
    });
    dispatch(mergeTaskPropertyUpdates({
      taskIds: selection,
      propertyUpdates
    }));
    clearSelection();
  }, [clearSelection, dispatch, selection]);
  return /*#__PURE__*/_jsx(DefaultBulkAddToQueueButton, {
    modalProps: {
      logFunction: logBulkActionUpdate,
      onSuccess
    }
  });
}